import { Link, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';
import Iconify from 'src/components/iconify';

interface Props {
  icon: string;
  label: string;
  href?: string;
  external?: boolean;
  children: ReactNode;
}

/** Primary icon and label followed by the value, as on the clinic business card. */
export default function InvitationContactRow({
  icon,
  label,
  href,
  external,
  children,
}: Props): JSX.Element {
  return (
    <Stack direction="row" alignItems="center" flexWrap="wrap" columnGap={1}>
      <Stack direction="row" alignItems="center" gap={0.5}>
        <Iconify icon={icon} sx={{ color: 'primary.main' }} />
        <Typography variant="body2" color="primary.main">
          {label}
        </Typography>
      </Stack>
      {href ? (
        <Link
          href={href}
          variant="body2"
          {...(external && { target: '_blank', rel: 'noopener noreferrer' })}
          sx={{
            textDecoration: 'underline',
            color: 'text.primary',
            overflowWrap: 'anywhere',
          }}
        >
          {children}
        </Link>
      ) : (
        <Typography variant="body2" sx={{ overflowWrap: 'anywhere' }}>
          {children}
        </Typography>
      )}
    </Stack>
  );
}
